import React from "react"
import { Link } from "gatsby"

export default function Footer(props) {
  return <footer className="landingFooter" id="footer">
    <div className="footerContent">
      <div className="footerSection sectionLegal">
        <p className="copyright">© 2021, CueHit Inc. All Rights Reserved.</p>

        <div className="footerActions">
          <a href="https://www.facebook.com/CueHit-105660121216936" className="actionItem">Facebook</a>
          <a href="https://www.linkedin.com/company/cuehit-inc/" className="actionItem">LinkedIn</a>
          <Link to="/about/" className="actionItem">About</Link>
          <Link to="/blog/" className="actionItem">Posts</Link>
          <Link to="/news/" className="actionItem">News</Link>
          <Link to="/contact/" className="actionItem">Contact</Link>
          <Link to="/terms-of-service/" className="actionItem">Terms</Link>
          <Link to="/disclaimer/" className="actionItem">Disclaimer</Link>
          <Link to="/privacy-policy/" className="actionItem">Privacy</Link>
        </div>
      </div>
    </div>
  </footer>
}

